import BaseModelInstance from './base.model'
import { UserEmailHistory as ModelDefinition } from './model-definitions'

class UserEmailHistory extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserEmailHistory
